import axios from "../api/axios";
import useAuth from "./useAuth";

const REFRESH_URL = "/refresh";

const useRefreshToken = () => {
	const { auth } = useAuth();

	const refresh = async () => {
		let accessTokenReturn = null;
		try {
			 
			accessTokenReturn = auth?.accessToken;
			 

			return accessTokenReturn;
		} catch (e) {
			console.log(e);
		}
		// const RefreshData = response?.data?.RefreshData;
		// console.log("RefreshData*****", RefreshData);
	};
	return refresh;
};

export default useRefreshToken;
